import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const Guarantee = () => {
  return <section className="py-20 md:py-24 bg-[#0a0a0a]" data-id="element-32">
      <div className="container mx-auto px-4" data-id="element-33">
        <FadeIn data-id="element-34">
          <div className="relative max-w-[600px] mx-auto bg-[#111111] rounded-2xl p-8 md:p-10 text-center overflow-hidden" style={{
          borderTop: '3px solid transparent',
          backgroundImage: 'linear-gradient(#111111, #111111), linear-gradient(90deg, #ADFF2F, #6ECC1F, #ADFF2F)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box'
        }} data-id="element-35">
            {/* Shield circle */}
            <div className="w-20 h-20 rounded-full bg-[#ADFF2F] flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(173,255,47,0.4)]" data-id="element-36">
              <span className="text-4xl" data-id="element-37">🛡️</span>
            </div>

            {/* Badge */}
            <div className="inline-block border border-[#ADFF2F] text-[#ADFF2F] text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 font-sans" data-id="element-38">
              Garantía Sin Riesgo
            </div>

            {/* Heading */}
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-39">
              🛡️ Garantía Total de 7 Días
            </h3>

            {/* Body */}
            <p className="text-gray-400 text-base md:text-lg leading-relaxed mb-6 font-sans max-w-md mx-auto" data-id="element-40">
              Descarga el plan hoy. Aplica los pasos. Si en 7 días sientes que
              no valió la pena, escríbeme y te devuelvo cada centavo. Sin
              formularios. Sin preguntas. Sin complicaciones.
            </p>

            {/* Divider */}
            <div className="h-px bg-white/10 my-6 max-w-xs mx-auto" data-id="element-41" />

            {/* Closing line */}
            <p className="text-[#ADFF2F] font-bold text-base md:text-lg font-sans m-0" data-id="element-42">
              ⚡ El riesgo es mío. El beneficio es tuyo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};